import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const TaxId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      id="propertyTaxId"
      name="propertyTaxId"
      label="Tax ID"
      placeholder="Enter tax ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TaxId;
